import styled from "styled-components"

export const Container = styled.div`
  margin-top: 12px;
  width: 100%;
  background: black;

  @media (max-width: 1025px) {
    margin-bottom: 50px;
  }
`
